import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppUser, AuthService } from '../../services/auth.service';
import { LoggingService } from '../../services/logging.service';
import { ManagerDashboardService } from '../../services/manager-dashboard.service';
import { User } from '../../models/user';
import { Subscription } from 'rxjs';
import { TenantRouterService } from '../../services/tenant-router.service';

@Component({
  selector: 'app-manager-dashboard',
  standalone: false,
  templateUrl: './manager-dashboard.component.html',
  styleUrl: './manager-dashboard.component.scss'
})
export class ManagerDashboardComponent implements OnInit, OnDestroy {

  userId !: number;
  managerId !: number;
  userRole !: string;
  user: User = new User();
  userSubscription !: Subscription;

  constructor(private router: Router, private authService: AuthService,
    private managerDashboardService: ManagerDashboardService,
    private loggingService: LoggingService, private tenantRouter: TenantRouterService
  ) { }

  ngOnInit(): void {
    this.loggingService.logDebug("Getting the userId from session storage");
    const userid = sessionStorage.getItem('user_id');
    if (userid) {
      this.userId = parseInt(userid, 10);
    }
    this.loggingService.logDebug("Getting the managerId from session storage");
    const managerid = sessionStorage.getItem('manager_id');
    if (managerid) {
      this.managerId = parseInt(managerid, 10);
    }
    this.loggingService.logDebug("Getting the userrole from session storage");
    const userrole = sessionStorage.getItem('user_role');
    if (userrole) {
      this.userRole = userrole;
    }

    this.userSubscription = this.managerDashboardService.getAllDetails(this.managerId,
      this.userId, this.userRole).subscribe((user) => {
        this.user = user;
        const appUser: AppUser = {
          UserID: user.UserID,
          Name: user.Name,
          Email: user.Email,
          IsActive: user.IsActive,
          personType: this.mapPersonType(user.personType)
        };

        this.authService.setCurrentUser(appUser);
      });
  }

  private mapPersonType(value: string): 'user' | 'manager' | 'hr' {
    const allowedTypes = ['user', 'manager', 'hr'];
    return allowedTypes.includes(value) ? (value as 'user' | 'manager' | 'hr') : 'user';
  }

  addUserTag() {
    this.tenantRouter.navigate('add-user-tag');
  }

  viewProgress() {
    this.tenantRouter.navigate('view-progress');
  }

  addNewTeamOrUser() {
    this.tenantRouter.navigate('register-dashboard');
  }

  logout(){
    this.authService.logout();
    this.tenantRouter.logoutRedirect();
  }

  ngOnDestroy(): void {
    this.userSubscription.unsubscribe();
  }

}
